import { HStack, VStack } from "@chakra-ui/react";
import RegisterHeading from "../../Components/RegisterHeading";
import FiscalNumberIdInput from "./FiscalNumberInput";
import {
  AddressCityInput,
  AddressCountryInput,
  AddressPostalCodeInput,
  AddressStreetInput,
} from "./Inputs";
import { useTranslations } from "next-intl";
import { INPUT_SPACING } from "pages/Register/RegisterPage";

const BillingAddress = ({ FormController, disabled }: { disabled: boolean, FormController: any }) => {
  const t = useTranslations("pages.register");
  return (
    <VStack
      spacing={INPUT_SPACING}
      w="full"
      align="start"
    >
      <RegisterHeading
        color="brandOrange.500"
        fontSize="4xl"
        mb="8"
      >
        {t("billingData")}
      </RegisterHeading>
      <FiscalNumberIdInput
        color="brandOrange.500"
        disabled={disabled}
        FormController={FormController}
      />
      <AddressStreetInput
        color="brandOrange.500"
        disabled={disabled}
        FormController={FormController}
      />
      <HStack w="full" spacing={5}>
        <AddressPostalCodeInput
          color="brandOrange.500"
          disabled={disabled}
          FormController={FormController}
        />
        <AddressCityInput
          color="brandOrange.500"
          disabled={disabled}
          FormController={FormController}
        />
      </HStack>
      <AddressCountryInput
        color="brandOrange.500"
        disabled={disabled}
        FormController={FormController}
      />
    </VStack>
  );
};

export default BillingAddress;
